import PropTypes from "prop-types";

// material-ui
import { Divider, List, Typography, Box } from "@mui/material";

// project imports
import NavItem from "../NavItem";
import NavCollapse from "../NavCollapse";

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case "collapse":
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case "item":
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 1.5,
                mt: item.id === "dashboard" ? 0 : 3,
              }}
            >
              <Box
                sx={{
                  width: 4,
                  height: 20,
                  background:
                    "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: 2,
                  mr: 1.5,
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: "#667eea",
                  fontWeight: 700,
                  fontSize: "0.875rem",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
                display="block"
                gutterBottom
              >
                {item.title}
              </Typography>
            </Box>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      {item.title && (
        <Divider
          sx={{
            mt: 2,
            mb: 1,
            borderColor: "rgba(102, 126, 234, 0.1)",
          }}
        />
      )}
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
};

export default NavGroup;
